import z from 'zod';

export const isValidEmail = (email: string) => {
  if (!email) return false;
  const parsedEmail = z.email().safeParse(email);
  return parsedEmail.success;
};
